import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Scroll to top on every route change
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}